import React from 'react'
import { AutocompletePickerCP } from 'submodules/nerit-framework-ui/common/components/form-fields/autocomplete-picker/AutocompletePickerCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { FieldRegulationRequests } from 'submodules/nerit-aquatec-sdk/services/regulation/FieldRegulationRequests'

interface ICPProps {
    value?: number
    isRequired?: boolean
    isMany?: boolean
    onChange?: (code: number) => void
    fieldName?: string
    formStateManager?: IFormStateManager<any>
    maxTagCount?: number
    returnFullOption?: boolean
    auxFieldNameSelectedOption?: string
}

export function SelectFieldCP(props: ICPProps): JSX.Element {

    return (
        <AutocompletePickerCP
            label={'Parâmetro'}
            requestConfigGetter={FieldRegulationRequests.getFieldList}
            showOptionsOnLoad={true}
            required={!!props.isRequired}
            isMultiple={!!props.isMany}
            value={props.value}
            onChange={(option: any) => {
                if (!!option && !!props.formStateManager && !!props.auxFieldNameSelectedOption)
                    props.formStateManager.changeFieldValue(props.auxFieldNameSelectedOption, option.label)
                if (!!props.onChange)
                    props.onChange(option)
            }}
            returnFullOption={true}
            filterOption={true}
            formStateManager={props.formStateManager}
            fieldName={props.fieldName}
            maxTagCount={props.maxTagCount}
            sortAlphabetically={true}
        />
    )
}
